// extracted by mini-css-extract-plugin
export var arrows = "_38-6";
export var decrementer = "_38-a";
export var disabled = "_38-4";
export var error = "_38-1";
export var hiddenText = "_38-b";
export var incrementer = "_38-9";
export var input = "_38-8";
export var inputWrapper = "_38-0";
export var leadingIcon = "_38-c";
export var readonly = "_38-3";
export var regular = "_38-7";
export var small = "_38-5";
export var warning = "_38-2";